import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { fromEvent } from 'rxjs';
import { SvcServices }  from './svc.service';
import { ContentService } from './content.service';
import { windowService } from './window.service';
import { SiteCatalystPageData } from 'app/models';
import { SiteCatalystTriggerService } from './site-catalyst-trigger.service';


//import { Cookie } from 'ng2-cookies/ng2-cookies';

type siteCatEventType = 'load' | 'viewDisplayed';

@Injectable()
export class SiteCatalystService {

      // static readonly DOMAIN: String = window.location.hostname;

      private window: any;
      private svcService: any;
      private contentService: any;
      private globalData: any;
      private detailedPageName: string;
      private pageLoaded: boolean = false;

      private siteCatEventValueMap: any = {
            load: 'fusionPageLoad',
            viewDisplayed: 'fusionModuleViewDisplayed',
            formInteraction: 'fusionFormInteraction',
            dmarAdsLoaded: 'fusionDmarAdsLoaded',
            dmarAdInteraction: 'fusionDmarAdInteraction',
            mpdTooltipInteraction: 'fusionMinPaymentDueTooltipInteraction',
            cardSelectorInteraction: 'fusionCardSelectorInteraction',
            speedbumpContinue: 'fusionSpeedbumpContinue',
            speedbumpCancel: 'fusionSpeedbumpCancel',
            speedbumpDisplay: 'fusionSpeedbumpDisplay',
            customDropdownInteraction: 'fusionCustomDropdownInteraction',
            customFormInteraction: 'fusionCustomFormInteraction',
            customFormSubmission: 'fusionCustomFormSubmission',
        	  linkClick: 'fusionLinkClick',
            customMinorInteraction: 'fusionCustomMinorInteraction',
            error: 'fusionErrorDisplayed',
            signonSuccess: 'fusionSignonSuccess',

      }

      private siteCatFormMap: any = {
            TEXT: 'text',
            CHECKBOX: 'checkbox',
            RADIO: 'radio',
            ANCHOR: 'A'
      }

      constructor(private _window: windowService, private _svcService: SvcServices, private _contentService: ContentService, private _triggerService: SiteCatalystTriggerService) {
            this.window = _window.nativeWindow;
            this.svcService = _svcService;
            this.contentService = _contentService;
            this._svcService.isSignOnLoaded.subscribe((data)=>{
                  if(data) {
                        this.pageLoaded = true;
                  }
            });
      }
      /**
      *  This is a public method exposed to set page level data to be passed to site catalyst.
      *
       */

      public setSCPageData(eventType: String, pageData: SiteCatalystPageData, eventObject?: any) {

            //attaching passed in variables to the dataLayer
            Object.assign(this.window.dataLayer, pageData);

            // if (!this.globalData)
            //       this.setGlobalData();

            //attaching additional variables from this file to the dataLayer
            this.window.dataLayer.siteId = this.getQueryStringVariable("siteId").toUpperCase();
            if (this.getQueryStringVariable("brandId") !== undefined && this.getQueryStringVariable("brandId") !== null && this.getQueryStringVariable("brandId") !== '') {
                  this.window.dataLayer.brandId = this.getQueryStringVariable("brandId").toUpperCase();
            } else {
                  this.window.dataLayer.brandId = this.getBrandId();
            }
            this.window.dataLayer.cyotaId = this.getCyotaId();
            this.window.dataLayer.ccsid = this.getCcsid();
            this.window.dataLayer.merchantName = this.getMerchantName();
            this.window.dataLayer.langId = this.getQueryStringVariable("langId") || "en_US";
            this.window.dataLayer.sysPrinAgent = this.getSysPrinAgent();
            this.window.dataLayer.cardType = this.getCardType();
            this.window.dataLayer.partnerBadge = this.getPartnerBadge();
            this.window.dataLayer.cops = this.getCOPS();
            this.window.dataLayer.uniqueId = this.getuniqueId();
            this.window.dataLayer.accountInstanceId = this.getAccountInstanceId();
            this.window.dataLayer.prevPageName = null;
            if(this.globalData && this.globalData.dataLayer && (this.globalData.dataLayer.miscFieldSix || this.globalData.dataLayer.miscFieldSix === "" )){
                  this.window.dataLayer.miscFieldSix = this.globalData.dataLayer.miscFieldSix;
              }
              if(this.globalData && this.globalData.dataLayer && (this.globalData.dataLayer.authorizedUserType || this.globalData.dataLayer.authorizedUserType === "" )){
                    this.window.dataLayer.authorizedUserType = this.globalData.dataLayer.authorizedUserType;
            }
            this.svcService.setModuleRestarted(false);


            if (this.siteCatEventValueMap[<siteCatEventType>eventType]) {
                  if(this.window.dataLayer.siteId == "PLCN_WFCC"){
                        //this._triggerService.trackBrandSpecificTag();
                        let brandID = this.getQueryStringVariable("brandId");
                        if(brandID){
                              this.window.s.eVar58 = this.window.s.prop58 = brandID
                        }
                        else{
                              this.window.s.eVar58 = this.window.s.prop58 = 'WF';
                        }
                  }
                  if (eventType == "load") {
                        setTimeout(() => {
                              this._triggerService.triggerPageLoad();
                        }, 2000);
                  }
                  else if (eventType == "viewDisplayed") {
                        let viewName = eventObject.getAttribute("data-view");
                        let moduleName = eventObject;
                        if(!moduleName.getAttribute("data-module"))
                              while ((moduleName = moduleName.parentElement) && !moduleName.getAttribute("data-module"));
                        moduleName = moduleName.getAttribute("data-module");
                        setTimeout(() => {
                              this._triggerService.triggerViewDisplayed(eventObject);
                        }, 1000);
                  }
                  else {
                        setTimeout(() => {
                              this._triggerService.invokeEventSpecificCalls(this.siteCatEventValueMap[<siteCatEventType>eventType], eventObject);
                        }, 0);
                  }
            }
            else {
                  this._triggerService.invokeEventSpecificCalls(eventType, eventObject);
            }
      }

      public attachFormSCEvents(pageData): any {
            const inputs = document.querySelectorAll('input:not([data-dropdown-sc-name="map_dropdown"])');
            this.attachEvents(inputs, pageData);
            const dropdown = document.querySelectorAll('select');
            this.attachEvents(dropdown, pageData);
            const anchorLink = document.querySelectorAll('a[role="link"]')
            this.attachEvents(anchorLink, pageData);
      }
      public attachEvents(inputs, pageData): void {

        for (let input of inputs) {
          if (input.type && input.type === this.siteCatFormMap["TEXT"]) {

              const subscription = fromEvent(input, 'blur').subscribe((e: any) => {
                if (e && e.target && e.target.value && e.target.value.length > 0) {
                      this.setSCPageData('formInteraction', pageData, input);
                      subscription.unsubscribe()
                };
              });

          } else {
              const subscription = fromEvent(input, 'change').subscribe((e: any) => {
                this.setSCPageData('formInteraction', pageData, input);
                subscription.unsubscribe()

              });
          }
            if (input.tagName && input.tagName === this.siteCatFormMap["ANCHOR"]) {

                    const subscription = fromEvent(input, 'click').subscribe((e: any) => {
                          this.setSCPageData('linkClick', pageData, input);
                          subscription.unsubscribe()
                    });

              }

        }
      }

      private setGlobalData(): any {
            this.globalData = this._contentService.getSignonResponse().response.body;
      }

      private getCyotaId(): String {
            var id = null;
            if(this.globalData){
                  if(this.globalData.cyotaUserIdentifier){
                      id = this.globalData.cyotaUserIdentifier;  
                  } else if(this.globalData.dataLayer){
                      id = this.globalData.dataLayer.cyotaID;
                  }
            }
            return id;   
      }

      private getCcsid(): String {
            return (this.globalData && this.globalData.dataLayer && this.globalData.dataLayer.ccsid) ? this.globalData.dataLayer.ccsid : null;
      }
  
      private getMerchantName(): String {
            return (this.globalData && this.globalData.dataLayer && this.globalData.dataLayer.merchantName) ? this.globalData.dataLayer.merchantName : null;

      }

      private getSysPrinAgent(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.sysPrinAgent : null;
      }

      private getCardType(): String {
            if (this.globalData && this.globalData.dataLayer && this.globalData.dataLayer.isDigital == "true")
                  return "Digital";
            return "Plastic";
      }
  
      private getBrandId(): String {
            var brandId = null;
            if (this.globalData && this.globalData.businessId && this.globalData.businessId == "MIL")
                brandId = this.globalData.businessId;
            return brandId;
      }

      private getPartnerBadge(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.partnerBadge : null;
      }

      private getCOPS(): String {
            return (this.globalData && this.globalData.dataLayer) ? this.globalData.dataLayer.copsIndicator : null;
      }

      private getAccountInstanceId(): string {
            return (this.globalData && this.globalData.accountInstanceId) ? this.globalData.accountInstanceId : null;
      }


      private getuniqueId(): string {
            return (this.globalData && this.globalData.dataLayer && this.globalData.dataLayer.uniqueId) ? this.globalData.dataLayer.uniqueId : null;
      }

      private getQueryStringVariable(variable): String {
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                  var pair = vars[i].split("=");
                  if (pair[0] == variable) {
                        return pair[1];
                  }
            }
      }

}
